import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import classes from "./FoodOrderSpecificationItemCard.module.scss"

const FoodOrderSpecificationItemCard = props => {
  const { orderItemQuantity, specificationItem } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <div className={classes["name"]}>
        {specificationItem.name}
        {
          !specificationItem.isSelectable &&
          <Fragment>
            <MdClose />
            <b>
              {specificationItem.quantity * orderItemQuantity}
            </b>
          </Fragment>
        }
      </div>
      {
        specificationItem.salePrice > 0 &&
        <div className={clsx(classes["price"], isLtr && classes["price-ltr"])}>
          {thousandSeparator(
            orderItemQuantity *
            specificationItem.salePrice *
            (specificationItem.quantity - specificationItem.freeQuantity)
          )}
        </div>
      }
    </div>
  )
}

export default FoodOrderSpecificationItemCard